import type { ChangeEvent } from 'react';

interface RequestSelectionCheckboxProps {
  checked: boolean;
  label: string;
  onToggle: (shiftKey: boolean) => void;
}

// WHY (#2800): request-list selection is the only checkbox-row consumer;
// a feature-local native control avoids introducing an unapproved shared primitive.
export function RequestSelectionCheckbox({
  checked,
  label,
  onToggle,
}: RequestSelectionCheckboxProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    event.stopPropagation();
    const nativeEvent = event.nativeEvent;
    const shiftKey = nativeEvent instanceof MouseEvent && nativeEvent.shiftKey;
    onToggle(shiftKey);
  };

  return (
    <input
      type="checkbox"
      checked={checked}
      aria-label={label}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      onChange={handleChange}
      style={{
        width: 'var(--s-5)',
        height: 'var(--s-5)',
        margin: 0,
        accentColor: 'var(--accent-1)',
        cursor: 'pointer',
      }}
    />
  );
}
